import FiltersColumn from "common/Filters/FiltersColumn/FiltersColumn";
import FunnelPlotOutlined from "@ant-design/icons/FunnelPlotOutlined";
import React, { useContext } from "react";
import { GRID_GAP } from "common/Layouts/TwoChartsTableLayout";
import { PageWrapperContext } from "../PageWrapper.context";
import { HEADER_ICON_SIZE } from "@shared/common/Themes/constants";
import useMedia from "utils/hooks/useMedia";
import { SMALL_MOBILE } from "common/constants";
import HeaderIconWithBadge from "common/Home/Header/HeaderIconWithBadge";
import { useTheme } from "styled-components";
import { useSelector } from "react-redux";
import Drawer from "common/Drawers/Drawer";
import { PageWrapperFiltersContext } from "common/Home/PageWrapperFilters.context.ts";

export const MobileFilters = () => {
  const appTheme = useTheme();
  const { mobileFiltersOpen, setMobileFiltersOpen } =
    useContext(PageWrapperContext);
  const { filters } = useContext(PageWrapperFiltersContext);
  console.log("filters", filters);
  const isSmallMobile = useMedia(
    [`(max-width: ${SMALL_MOBILE})`],
    [true],
    false
  );

  const numActiveFilters = filters
    ? useSelector(filters.selectors.selectNumActiveFilters)
    : 0;

  return (
    <>
      {filters && (
        <HeaderIconWithBadge
          icon={
            <FunnelPlotOutlined
              style={{
                fontSize: HEADER_ICON_SIZE,
                marginRight: 10,
              }}
              onClick={() => setMobileFiltersOpen(!mobileFiltersOpen)}
            />
          }
          counterColor={appTheme.colors.primaryBlue}
          counterText={numActiveFilters > 9 ? "*" : numActiveFilters.toString()}
          showCounter={numActiveFilters > 0}
          oneDigit={true}
          isActive={mobileFiltersOpen}
        />
      )}
      <Drawer
        styles={{
          body: {
            padding: GRID_GAP,
          },
        }}
        closable={false}
        open={mobileFiltersOpen}
        onClose={() => setMobileFiltersOpen(false)}
        width={300}
        destroyOnHidden={false}
      >
        {filters && (
          <FiltersColumn
            selectLoadingStates={filters.loadingStatesSelector}
            filtersActions={filters.actions}
            filtersSelectors={filters.selectors}
            hideFilterTypes={filters.hideFilterTypes}
            isLoading={filters.loading}
            closeMobileFilters={
              isSmallMobile ? () => setMobileFiltersOpen(false) : undefined
            }
          />
        )}
      </Drawer>
    </>
  );
};
